module.exports = __webpack_public_path__ + "static/img/bb2.9a9b6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb2.png
// module id = NDtY
// module chunks = 1